"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDirectoryAdapter = void 0;
const domain_1 = require("@home-health-notify/domain");
const Urls_1 = require("../Urls");
/* eslint-disable no-useless-catch */
class UserDirectoryAdapter {
    constructor(httpAdapter, config) {
        this.httpAdapter = httpAdapter;
        this.config = config;
    }
    getUserDirectory(organizationId, source, abortContext) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.directoryData, {
                    signal: abortContext === null || abortContext === void 0 ? void 0 : abortContext.newAbortSignal(new AbortController()),
                    headers: Object.assign(Object.assign({}, (organizationId && {
                        "x-hhn-active-org-id": organizationId,
                    })), (source && { "x-hhn-source": source })),
                });
                return (0, domain_1.CompletedResult)(response.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    getAppDirectory(source, abortContext) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.appData, {
                    signal: abortContext === null || abortContext === void 0 ? void 0 : abortContext.newAbortSignal(new AbortController()),
                    headers: Object.assign({}, (source && { "x-hhn-source": source })),
                });
                return (0, domain_1.CompletedResult)(response.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    getUserInfo(userId, source, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.userProfile(userId), Object.assign({ signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()) }, (source && { headers: { "x-hhn-source": source } })));
                return (0, domain_1.CompletedResult)(response.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    getUserWorkload(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(`${this.config.baseUrl}${Urls_1.urls.workload}?id=${userId}`);
                return response.data.data;
            }
            catch (e) {
                throw e;
            }
        });
    }
}
exports.UserDirectoryAdapter = UserDirectoryAdapter;
